import { ServerConfig } from "@/config/config";
import { Notification } from "@/models/notifications/notification";
import { Axios } from "@/utils/axios";
import { IInitAppResponse } from "./init-service";
import { MainSocketService } from "./main-socket-service";
import { EventEmitter } from "@/utils/event-emitter";
import { NotificationBuilder } from "@/models/notifications/notification-builder";
import Vue from "vue";

class NotificationServiceClass extends EventEmitter{
	private state = Vue.observable({hasPendingNotifications: false});
	initialized:boolean = false;
	readonly url:string = `${ServerConfig.host}/notifications`;

	get hasPendingNotifications():boolean {
		return this.state.hasPendingNotifications;
	}

	set hasPendingNotifications(value:boolean) {
		this.state.hasPendingNotifications = value;
	}

	async getNotifications(offset:number = 0):Promise<Notification[]> {
		let result = await Axios.get(`${this.url}`, {params: {offset}});
		return result.data.map((d:any) => NotificationBuilder.createNotification(d));
	}

	async getHasPendingNotifications():Promise<boolean> {
		let result = await Axios.get(`${this.url}/has-unread-notifications`);
		this.hasPendingNotifications = result.data;
		return this.hasPendingNotifications;
	}

	async markNotificationsAsRead(notifications:Notification[] = []):Promise<void> {
		await Axios.post(`${this.url}/mark-as-read`, notifications.map(n => n.ID));
		await this.getHasPendingNotifications();
	}

	async deleteReadNotifications():Promise<void> {
		await Axios.post(`${this.url}/delete-all-read`);
		await this.getHasPendingNotifications();
	}

	init(data:IInitAppResponse) {
		if (!this.initialized) {
			this.initialized = true;
			MainSocketService.on("/notification/new", (data:any) => {
				let notification = NotificationBuilder.createNotification(data);
				this.hasPendingNotifications = true;
				this.emit("new-notification", notification);
			});
			MainSocketService.on("user-connected", (data:any) => {

			});
		}
		this.hasPendingNotifications = data.HasUnreadNotifications;
	}

	async setHideFromClient(notification:Notification, hidden:boolean):Promise<Notification>{
		let result = await Axios.post(`${this.url}/${notification.ID}/set-hide-from-client`, {Enabled: hidden});
		return NotificationBuilder.createNotification(result.data);
	}
};

export const NotificationService = new NotificationServiceClass();